import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PRODUCT_IMAGE_URL } from "constant";
import { useMediaQuery } from "@mui/material";

const ProductSliderNew = ({ images }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isDesktop = useMediaQuery("(min-width: 1100px)");

  const settings = {
    className: "center",
    centerMode: !isMobile,
    infinite: true,
    centerPadding: isMobile ? "0px" : "200px",
    slidesToShow: 1,
    speed: 1000,
    nextArrow: null,

    autoplay: true,
    autoplaySpeed: 3000,

    beforeChange: () => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    },
  };
  return (
    <div className="detail-product-slider">
      <Slider {...settings} className="carousel">
        {images.map((img, index) => (
          <div
            className={`singleCarousel`}
            key={index}
            // onClick={() => onSideSwiperChange(index)}
          >
            {/* <img src={`${PRODUCT_IMAGE_URL}${img}`} alt={img + " - " + index} /> */}
            <img src={img} alt={img + " - " + index} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ProductSliderNew;
